export const FLOATING_COUPON_LOGIN_SITUATION = '浮窗领券';
export const DEFAULT_LOGIN_SITUATION = '其他';
export const GOODS_DETAIL_GET_COUPON_SITUATION = '商品详情页';
export const GOODS_DETAIL_COUPON_LOGIN_SITUATION = '商详-领券';

interface ResolveLoginSituationOptions {
  loginSituation?: string;
  isFloatingCouponEntry?: boolean;
  getCouponSituation?: string;
}

export function resolveLoginSituation(options: ResolveLoginSituationOptions): string {
  const { loginSituation, isFloatingCouponEntry = false, getCouponSituation } = options;
  if (getCouponSituation === GOODS_DETAIL_GET_COUPON_SITUATION) {
    return GOODS_DETAIL_COUPON_LOGIN_SITUATION;
  }
  const normalized = typeof loginSituation === 'string' ? loginSituation.trim() : '';
  if (isFloatingCouponEntry && (!normalized || normalized === DEFAULT_LOGIN_SITUATION)) {
    return FLOATING_COUPON_LOGIN_SITUATION;
  }
  return normalized || DEFAULT_LOGIN_SITUATION;
}
